// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"B3VT6TqWCF59maNQ5s0Mo","video":"_3D5LPNMQvhqEel8aKtgRqO"};